import React, { useContext } from 'react';
import c from 'classnames';
import { ThemeSurface } from '@wix/da-react-context/pkg/constants';
import { PopupContext } from '../../../popups/PopupContext';
import ModalBody from '../../base/ModalBody';
import ModalFormBody from '../../base/ModalFormBody';
import s from './HeaderlessLayout.scss';
/**
 * A lobotomized version of dsPresets/ModalLayout (see note in HeaderlessModal for reasons)
 */ const HeaderlessLayout = ({ isFullscreen, content, className, contentClassName, innerScrollRef, onSubmit, withScrollableContentWrapper = true })=>{
    const { setDefaultScrollableRef } = useContext(PopupContext);
    const children = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: c(s['content'], withScrollableContentWrapper && s['scrollable'], contentClassName),
        ref: (node)=>{
            if (withScrollableContentWrapper) {
                innerScrollRef && innerScrollRef(node);
                // Set the default scrollable, see ModalRoot for the logic
                setDefaultScrollableRef && setDefaultScrollableRef(node);
            }
        }
    }, content));
    return onSubmit ? /*#__PURE__*/ React.createElement(ModalFormBody, {
        className: c(s['root'], isFullscreen && s['fullscreen'], className),
        surfaceType: ThemeSurface.TERTIARY,
        isFullscreen: isFullscreen,
        onSubmit: onSubmit
    }, children) : /*#__PURE__*/ React.createElement(ModalBody, {
        className: c(s['root'], isFullscreen && s['fullscreen'], className),
        surfaceType: ThemeSurface.TERTIARY,
        isFullscreen: isFullscreen
    }, children);
};
HeaderlessLayout.displayName = 'HeaderlessLayout';
export default HeaderlessLayout;

//# sourceMappingURL=HeaderlessLayout.js.map